import { map } from 'lodash'

const challengeRelationsDetailsFormInitialValues = ({
  dishTypes,
  cuisineTypes,
  type,
}) => ({
  dishTypes: map(dishTypes, 'id'),
  cuisineTypes: map(cuisineTypes, 'id'),
  type,
})

export default challengeRelationsDetailsFormInitialValues
